import { render, staticRenderFns } from "./form-create.vue?vue&type=template&id=589b7b8f&"
import script from "./form-create.vue?vue&type=script&lang=ts&"
export * from "./form-create.vue?vue&type=script&lang=ts&"
import style0 from "./form-create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports